import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import EditableRoleChip from "../../../components/chips/editable-role-chip";
import { Organisation, User } from "../../../types";

interface TeamMembershipItemProps {
  user: User;
  team: Organisation;
}

const TeamMembershipItem: React.FC<TeamMembershipItemProps> = ({
  user,
  team,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxSizing: "border-box",
        border: `1px solid ${team.color}`,
        borderRadius: "8px",
        px: 1,
        py: 0.75,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1.5}
        sx={{ width: "100%", minWidth: 0 }}
      >
        <Typography
          variant="body2"
          sx={{
            color: team.color,
            fontWeight: 600,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {team.name}
        </Typography>

        <EditableRoleChip
          user={user}
          team={{
            teamId: team.organisationId,
            name: team.name,
            color: team.color,
          }}
          chipSize="small"
          chipHeight="20px"
          chipFontSize="0.7rem"
        />
      </Stack>
    </Box>
  );
};

export default TeamMembershipItem;
